import React from 'react';
//scss
import './ProjectD.scss';
//icons
import TierraBruja from '../Icons/tierrabruja';

class ProjectD extends React.Component {
  constructor() {
    super();
    this.backgroundRef = React.createRef();
    this.underlineRef = React.createRef();
  }
  onHoverOn = () => {
    const isFirefox = typeof InstallTrigger !== 'undefined';
    if (isFirefox === false) {
      const background = this.backgroundRef.current;
      background.classList.toggle('background_hover');
    }
    const underline = this.underlineRef.current;
    underline.classList.toggle('underline_hover');
  };

  onHoverOut = () => {
    const isFirefox = typeof InstallTrigger !== 'undefined';
    if (isFirefox === false) {
      const background = this.backgroundRef.current;
      background.classList.toggle('background_hover');
    }
    const underline = this.underlineRef.current;
    underline.classList.toggle('underline_hover');
  };
  render() {
    return (
      <div className="ProjectD_wrapper" >
        <div className="ProjectD" name="Projects">
          <div className="ProjectD_background" ref={this.backgroundRef}></div>
          <div
            className="ProjectD_content"
            onMouseEnter={this.onHoverOn}
            onMouseLeave={this.onHoverOut}
          >
            <TierraBruja />
            <div className="ProjectD_content_Text">
              <div className="ProjectD_content_Text_title">
                <a href="http://www.tierrabruja.com/" target="_blank">
                  TIERRA BRUJA
                </a>
                <div
                  className="ProjectD_content_Text_title_underline"
                  ref={this.underlineRef}
                ></div>
              </div>
              <div className="ProjectD_content_Text_description">
                Landscape design that specializes in feeling the earth, not just
                seeing it.
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ProjectD;
